import DistributorNote from './distributornote'

export default DistributorNote
